import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Ccontinue(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>

      <Sides/>
       <Helmet>
 
       <title>Learn to use continue Statement in C++ with CodeExampler</title>
<meta name="description" content="Learn how to use the continue statement in C++ with CodeExampler's tutorial for beginners. This powerful keyword is typically used with an if statement to skip over specific iterations of a loop.making it easy to learn the fundamentals of programming in C++." />
<meta name="keywords" content="C++ continue keyword, continue statement in C++, C++ if continue, continue in while loop C++,learn C++ programming online C++ tutorial, CodeExampler" />
<link rel="canonical" href="https://www.codeexampler.com/cpp-continue" />
 </Helmet>
 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Continue Statement in c++</h1>
    <div className="first">
        <a href="/cpp-break"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-array"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
   
<p className="mt-4 para">A continue is usually associated with an if
</p>




<h2 className='headings'>Syntax for continue in C++:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7"> Continue </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>


<h2 className='headings'>Q-write a program loop starts from 1 to 10 but continues when i=4 in the continue statement in C++?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
           {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">  int  </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">;</span>
              {"\n"}
            <span className="qwerty-11">  for </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-5">1;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">&#60; =</span>
            <span className="qwerty-5">10;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">++</span>
            <span className="qwerty-3"> )</span>
              {"\n"}
              <span className="qwerty-3">  &#123; </span>
              {"\n"}
              <span className="qwerty-7"> if </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10">i </span>
              <span className="qwerty-3">== </span>
            <span className="qwerty-10">4 </span>
            <span className="qwerty-3">)</span>
              {"\n"}
               <span className="qwerty-3">  &#123; </span>
              {"\n"}
              <span className="qwerty-11"> continue </span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7"> cout </span>
            <span className="qwerty-3"> &#60;&#60; </span>
              <span className="qwerty-10">This is continue </span>
            <span className="qwerty-3"> " ;</span>
            {"\n"}
            <span className="qwerty-3">  &#125; </span>
            {"\n"}
            <span className="qwerty-7"> cout</span>
            <span className="qwerty-3"> &#60;&#60; </span>
              <span className="qwerty-10">i </span>
              <span className="qwerty-3"> &#60;&#60; " </span>
              <span className="qwerty-5">\n</span>
            <span className="qwerty-3"> " ;</span>
              {"\n"}
            <span className="qwerty-3">  &#125; </span>
              {"\n"}
            <span className="qwerty-3">&#125; </span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"} 
              <span className="qwerty-5">1 </span>
              {"\n"} 
              <span className="qwerty-5">2</span>
              {"\n"} 
              <span className="qwerty-5">3 </span>
              {"\n"} 
              <span className="qwerty-5">4 </span>
              {"\n"} 
              <span className="qwerty-5">5 </span>
              {"\n"} 
              <span className="qwerty-5">6 </span>
              {"\n"} 
              <span className="qwerty-5">7</span>
              {"\n"} 
              <span className="qwerty-5">8</span>
              {"\n"} 
              <span className="qwerty-5">9</span>
              {"\n"} 
              <span className="qwerty-5">10 </span>
                {"\n"} 
             </code>{"\n"}</pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a program loop starts from 1 to 10 but continues when i=4 or 8 in the continue statement in C++?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
           {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">  int  </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">;</span>
              {"\n"}
            <span className="qwerty-11">  for </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-5">1;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">&#60; =</span>
            <span className="qwerty-5">10;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">++</span>
            <span className="qwerty-3"> )</span>
              {"\n"}
              <span className="qwerty-3">  &#123; </span>
              {"\n"}
              <span className="qwerty-7"> if </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10">i </span>
              <span className="qwerty-3">== </span>
            <span className="qwerty-10">4 </span>
            <span className="qwerty-3">|| </span>
              <span className="qwerty-10">i </span>
              <span className="qwerty-3">== </span>
            <span className="qwerty-10">8</span>
            <span className="qwerty-3">)</span>
              {"\n"}
               <span className="qwerty-3">  &#123; </span>
              {"\n"}
              <span className="qwerty-11"> continue </span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7"> cout </span>
            <span className="qwerty-3"> &#60;&#60; </span>
              <span className="qwerty-10">This is continue </span>
            <span className="qwerty-3"> " ;</span>
            {"\n"}
            <span className="qwerty-3">  &#125; </span>
            {"\n"}
            <span className="qwerty-7"> cout</span>
            <span className="qwerty-3"> &#60;&#60; </span>
              <span className="qwerty-10">i </span>
              <span className="qwerty-3"> &#60;&#60; " </span>
              <span className="qwerty-5">\n</span>
            <span className="qwerty-3"> " ;</span>
              {"\n"}
            <span className="qwerty-3">  &#125; </span>
              {"\n"}
            <span className="qwerty-3">&#125; </span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"} 
              <span className="qwerty-5">1 </span>
              {"\n"} 
              <span className="qwerty-5">2</span>
              {"\n"} 
              <span className="qwerty-5">3 </span>
              {"\n"} 
              <span className="qwerty-5">4 </span>
              {"\n"} 
              <span className="qwerty-5">5 </span>
              {"\n"} 
              <span className="qwerty-5">6 </span>
              {"\n"} 
              <span className="qwerty-5">7</span>
              {"\n"} 
              <span className="qwerty-5">8</span>
              {"\n"} 
              <span className="qwerty-5">9</span>
              {"\n"} 
              <span className="qwerty-5">10 </span>
                {"\n"} 
             </code>{"\n"}</pre>
        </div>
      </div>




<h2 className='headings'>Q-Write a program loop starts from 1 to 10 but continues when i=4 or 8 in the continue statement in C++?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
           {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">  int  </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">;</span>
              {"\n"}
            <span className="qwerty-11">  for </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-5">1;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">&#60; =</span>
            <span className="qwerty-5">10;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">++</span>
            <span className="qwerty-3"> )</span>
              {"\n"}
              <span className="qwerty-3">  &#123; </span>
              {"\n"}
              <span className="qwerty-7"> if </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10">i </span>
              <span className="qwerty-3">% </span>
            <span className="qwerty-10">2 </span>
              <span className="qwerty-3">== </span>
            <span className="qwerty-10">0</span>
            <span className="qwerty-3">)</span>
              {"\n"}
               <span className="qwerty-3">  &#123; </span>
              {"\n"}
              <span className="qwerty-11"> continue </span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7"> cout </span>
            <span className="qwerty-3"> &#60;&#60; </span>
              <span className="qwerty-10">This is continue </span>
            <span className="qwerty-3"> " ;</span>
            {"\n"}
            <span className="qwerty-3">  &#125; </span>
            {"\n"}
            <span className="qwerty-7"> cout</span>
            <span className="qwerty-3"> &#60;&#60; </span>
              <span className="qwerty-10">i </span>
              <span className="qwerty-3"> &#60;&#60; " </span>
              <span className="qwerty-5">\n</span>
            <span className="qwerty-3"> " ;</span>
              {"\n"}
            <span className="qwerty-3">  &#125; </span>
              {"\n"}
            <span className="qwerty-3">&#125; </span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"} 
              <span className="qwerty-5">1 </span>
              {"\n"} 
              <span className="qwerty-5">3 </span>
              {"\n"} 
              <span className="qwerty-5">5 </span>
              {"\n"} 
              <span className="qwerty-5">7</span>
              {"\n"} 
              <span className="qwerty-5">9</span>
                {"\n"} 
             </code>{"\n"}</pre>
        </div>
      </div>


<h1 className="mt-5">  </h1>

<div className="back">
        <a href="/cpp-break"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-array"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div></div>
    </div>
)
}
export default Ccontinue;